
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'


export default {
name: 'date-box',
components: {
Flexbox,
FlexboxItem,
},
props: {
startDate: {
type: String,
default: '',
},
endDate: {
type: String,
default: '',
},
showTitle: {
type: Boolean,
default: true,
},
},
computed: {
lanName(){
return window.localStorage.getItem('lan_name');
},
},
methods: {
/** 打开日历 */
onOpenCld(){
this.$emit('on-click');
},
},
}



// WEBPACK FOOTER //
// ./src/components/DateBox/DateBox.vue